import ApiException from "@rmp/core/exceptions/apiException";

export default class CaptchaException extends ApiException {
	constructor() {
		super("Не удалось выполнить автоматическую проверку безопасности.");
	}
}
